export const API = {
  // BASE_URL: "https://server.bairuhatech.com/dgymbook/",
  // BASE_URL: 'https://xentrybook-uat-server.bairuhatech.com/', // development
  BASE_URL: "https://xentrybook-prod.bairuhatech.com/", // production new from phase 4
  // 1122

  // BASE_URL: "http://localhost:1122/",

  LOGIN: "user_auth/login",
  LIST_OFFICE: "office/all",
  ADD_OFFICE: "office/create",
  UPDATE_OFFICE: "office/update",
  GET_OFFICE_INFO: "office/office_info/",
  SEARCH_OFFICE: "office/search_office",

  CONTACT_ALL: "contact/all",
  CONTACT_CREATE: "contact/create",

  LIST_TRANSACTIONS: "transactions_new/all_transactions", //?order=ASC&page=1&take=10
  LIST_SUBSCRIPTIONS: "subscriptions/by_office/", // by office id
  SUBCRIPTION_DELETE_SOFT: "subscriptions/softDelete/", // post
  SUBCRIPTION_USERS: "users/user_by_subscription/", // get, delete :-- to get details of subscriptions
  SUBCRIPTION_ADD: "subscriptions/create", // post
  TRANSACTION_DELETE: "transactions_new/delete_transaction/",

  GET_INVOICE_DETAILS: "transactions_new/getInvoice/",

  USERS_ALL: "users/all",
  USERS_LIST: "users/list/",
  USERS_DELETE: "users/delete/",
  // USER_ADD: "users/create", // create USER or TRAINER

  USER_ADD: "users/create_new", //new create api
  ALL_USERS: "users/getAll", // for export Excel
  USER_DETAILS: "users/details/", //get user
  USER_BLOCK: "users/block",
  USER_UPDATE: "users/update",
  CHECK_ADMSN_ID: "users/check_admission_id",

  LOGGED_USERS: "log/byfilter", //?order=ASC&page=1&take=10
  LOGGED_USER_DETAILS: "log/userDetails", //?order=ASC&page=1&take=10

  GET_INVOICE: "transactions/findOne/",
  ALL_TRANS_BY_OFFICE: "transactions/export_excel/",

  PDF_GENERATE_URL: "https://pdf.taxgoglobal.com/getPdf",

  LIST_TRAINERS: "users/list_trainers/",
  TRAINER_UPDATE: "users/update/",
  BLOCK_TRAINER: "users/block/",

  BIRTHDAY_USERS: "dashboard/birthday_today/", //GET
  EXPIRED_USERS: "dashboard/expired_users/", // GET ?order=DESC&page=1&take=50
  // EXPIRING_USERS: 'dashboard/expiring_users/', // GET ?order=DESC&page=1&take=50
  EXPIRE_SOON_USERS: "dashboard/will_expire_soon/", // GET ?order=DESC&page=1&take=50
  USER_COUNT: "dashboard/count/", //GET
  SUBCRIPTION_ALL: "subscriptions/all/", // get :-- to get all list of Sub_all
  OFFICE_INFO_UPDATE: "office/update_more_info",
  USER_FILTER: "users/byfilter",
  list_office_Subs: "subscriptions/list_office_subs/",

  SUBCRIPTION_OFFICE: "subscriptions/by_office/", // get, delete :-- to get details of subscriptions
  SUBCRIPTION: "subscriptions/", // get, delete :-- to get details of subscriptions

  GET_ATTENDANCE: "users/attendance/",
  ATTENDANCE: "users/attendance_office/",

  TRANSACTIONS: "transactions/all_transactions", //POST
  ENROLL_FINGER: "users/enroll_finger",
  ENROLL_FACE: "users/enroll_face",
  HOLD_RESUME_ADD: "hold_resume/create",
  // REMOVE_SUB: 'users/remove_subscription',
  REMOVE_SUBSCRIPTION: "order/remove_sub", //new phase 4 api
  RENEW_SUB: "order/renew_sub", // new phase 4 renew subscription

  TRANSACTION_ADD: "transactions/create",
  TRANSACTION_SEARCH: "transactions/search",
  LIST_TRANSACTIONS_BY_OFFICE: "order/list_all_trans",
  TRANSACTION_TOTAL_2: "transactions/transactionTotal_2", // Transaction tab new api for avoid live and upcoming release api change conflict.
  PAY_DUE: "transactions/pay_due/",
  DUE_LIST_ALL: "order/pending_dues_by_office", //  due listing all users
  PAY_DUES: "order/pay_dues",

  // NEW Transactions
  LIST_USER_TRANSACTIONS: "transactions_new/all_transactions", // list a user's transactions in user details (app) old api TRANSACTIONS
  LIST_USER_DUES: "order/list_dues", // listing dues in each plan inside due payment page in user details

  UPDATE_PASS: "user_auth/change_password",
  CONTACT_US: "contact/create",
  DUES_LIST: "transactions/dues_by_user",
  IMAGE_COMPRESS: "img_compress/compress",
  LIST_TOKEN: "subscriptions/list_plans",
};
